// Cena 3 — Conexões / WhatsApp (áudio ~26s)
// O cursor vai até o botão REAL "Adicionar WhatsApp", clica, e o QR
// fictício surge centralizado (com blur automático). O celular "escaneia",
// conecta, e as mensagens começam a chegar.
const MAIN = "[data-tour='main-content']";
const BTN_ADD = "[data-tour='btn-add-whatsapp']";

export default async function connections(ctx) {
	// destaca o botão real de adicionar conexão
	await ctx.waitFor(BTN_ADD);
	ctx.spotlight(BTN_ADD);
	await ctx.wait(1200);

	// "...clique em Adicionar WhatsApp"
	await ctx.cursorTo(BTN_ADD, { duration: 1000 });
	await ctx.wait(1600);
	await ctx.click(BTN_ADD);
	await ctx.wait(600);

	// o modal do QR centraliza sozinho e ativa o blur de fundo —
	// o spotlight do botão sai de cena para não competir com o modal
	ctx.spotlight(null);
	const qr = ctx.mount("qrCard", MAIN, { status: "qr" });
	await ctx.waitFor("[data-demo='qr']");

	// cursor sai da frente para não tampar o QR
	await ctx.cursorTo({ sel: MAIN, ax: 0.8, ay: 0.72 }, { duration: 800 });
	await ctx.wait(1200);

	// "Pegue o celular... WhatsApp → Aparelhos conectados... escaneie"
	const phone = ctx.mount("toast", MAIN, {
		icon: "📱",
		text: "WhatsApp → Aparelhos conectados → Conectar aparelho",
	});
	await ctx.wait(5200);
	await ctx.wait(2000); // "...e escaneie o código"
	ctx.unmount(phone);
	await ctx.wait(500);

	// escaneado! conectando…
	ctx.update(qr, { status: "connecting" });
	await ctx.wait(1500);

	// "Pronto!" — conectado
	ctx.update(qr, { status: "connected" });
	await ctx.wait(1400);

	// as mensagens dos clientes já começam a chegar
	const toast = ctx.mount("toast", MAIN, {
		icon: "💬",
		text: "Mensagens chegando!",
	});
	await ctx.wait(1800);

	// cursor descansa num canto enquanto a narração fecha o passo
	await ctx.cursorTo({ sel: MAIN, ax: 0.5, ay: 0.78 }, { duration: 900 });
	await ctx.wait(2200);

	// estado final: QR conectado permanece em cena
	ctx.unmount(toast);
	await ctx.wait(400);
	ctx.spotlight(null);
}
